import { FC } from 'react'

import { EmptyResult, Spinner } from '../../../../components'
import { StatisticRowBoxes } from './StatisticRowBox'
import Styles from './Statistics.module.scss'
import { StatisticsBoxes } from './StatisticsBoxes'
import { useTranslation } from 'react-i18next'

interface Props {
    performance?: performanceRequest
}
export const Statistics: FC<Props> = ({ performance }) => {
    const { t } = useTranslation()
    return (
        <div className={Styles.container}>
            {!performance?.data &&
            performance?.validation?.status_code !== '0001' ? (
                <Spinner />
            ) : performance &&
              performance.data &&
              performance.validation?.status_code === '0000' ? (
                <>
                    <StatisticsBoxes performance={performance.data} />
                    <StatisticRowBoxes performance={performance.data} />
                </>
            ) : (
                <EmptyResult description={t('txt_statistics_des')} />
            )}
        </div>
    )
}
